import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'

const BuildTeam = () => {
  return (
    <>
        <Card className='no-border rounded-0 industrial-modeling-top-section container build-a-team py-5 py-md-0'>
            <Card.Body>
                <Card.Title className='text-center industrial-modeling-title pt-md-5'>Build a Team</Card.Title>
                <Card.Subtitle className="text-center build-team-subheading  py-4">Developer as a Service program</Card.Subtitle>
                <Card.Text className='text-left build-team-content'>
                Leading companies see the benefits of AR and VR. But one of the biggest challenges to bringing programs to life is talent: artists, developers, and engineers that have the experience to build AR/VR content and platforms
                </Card.Text>

                <Card.Title className='text-left build-team-heading'>Embracing the Remote Workforce</Card.Title>
                <Card.Text className='text-left build-team-content'>
                Finding, vetting, and hiring internal VR talent is expensive, time-consuming, and hit-or-miss. AR/VR skills are specialized, and available talent is difficult to find without paying a premium. <br />  <br /> We take advantage of highly skilled, affordable talent from around the world. We identify, vet, onboard, and train top engineers, designers, artists, and more so they’re ready to start working on your team now. You can ramp up quickly, go to market with your project, and know you’re working with the top AR/VR talent.
                </Card.Text>

                <Card.Title className='text-left build-team-heading'>Moving Away from the “Project” Mindset</Card.Title>
                <Card.Text className='build-team-content text-left'>
                As an external service provider, clients often come to us thinking about a single project. But we want to be a partner through the lifecycle of AR/VR development—going beyond what might be considered a single project. <br />  <br /> With Paracosma’s Build a Team program, our team becomes your team. We can create a dedicated team, made of full-time and part-time specialists, that works with you just like an internal team would. But when you build a team, instead of trying to hire yourself, you get:
                </Card.Text>
                <Row className='px-md-0 px-sm-2 py-md-4 '>
                    <Col xs={{span:12, offset:0}} md={{span:5, offset:1}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={process.env.PUBLIC_URL + "assets/icons/bt_001.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text>Flexibility to shift specialists as your needs change</Card.Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={process.env.PUBLIC_URL + "assets/icons/bt_002.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text>All-in pricing</Card.Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12, offset:0}} md={{span:5, offset:1}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={process.env.PUBLIC_URL + "assets/icons/bt_003.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text>Done-for-you recruiting, hiring, onboarding, certification, and ongoing skills development</Card.Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="py-2 py-md-2 px-md-0 px-sm-4">
                        <Row className='px-md-0 px-3'>
                            <Col xs={{span:1, offset:0}} className="no-padding-x">
                                <Card.Img className='photography-icon align-self-start' src={process.env.PUBLIC_URL + "assets/icons/bt_004.png"} alt="" />
                            </Col>
                            <Col xs={{span:10, offset:0}} className="text-start">
                                <Card.Text>The latest tools and technologies for team members to use</Card.Text>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Card.Text className='container build-team-content text-left team-build-buttom-heading'>  Paracosma DAAS Teams have been placed with: </Card.Text>
                
                <Row className='no-padding-x'>
                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'>A leading VR Healthcare company developing digital therapeutics for FDA approval</Card.Text>
                    </Col>

                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'>A leading online university specializing in immersive education </Card.Text>
                    </Col>

                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'>A VR enterprise productivity app, helping with file conversions and 3rd-party integrations</Card.Text>
                    </Col>

                    <Col xs={{span:2, offset:0}} className="square-icon-container">
                     <Card.Img className='photography-square-icon align-self-end' src={process.env.PUBLIC_URL + "assets/icons/square.png"} alt="" />
                    </Col>
                    <Col xs={{span:10, offset:0}} className="text-start">
                        <Card.Text className='build-team-list-text d-sm-inline-block mx-md-1'>An executive recruiting and onboarding company</Card.Text>
                    </Col>
                </Row>

                <Card.Title className='text-left build-team-heading'>Build Your Team</Card.Title>
                <Card.Text className='text-left build-team-content'>
                Let’s talk through your goals, and then we can identify the ideal makeup of your team, provide an estimate, and get to work.
                </Card.Text>

                

             
            </Card.Body>
            <Button className='build-team-request-button shelterinplacevr-button btn btn-warning text-center'> <a href="https://www.paracosma.com/#contact-form" target="_blank" rel="noreferrer">Request a Consultation</a></Button>

        </Card>
      
    </>
  )
}

export default BuildTeam
